var redux = require('redux'),
    reactRedux = require('react-redux'),
    HomePage = require('./components/HomePage') // not sure if necessary

console.log("checking redux:", redux)
console.log("checking reactRedux:", reactRedux)

var initialState = {
  test: true,
}
function reducer(state, action){
  // reducer will listen for different actions
  // and change state accordingly before
  // returning a modified state to our components
  console.log("STATE: ", state)
  console.log("ACTION: ", action)
  //We're not manipulating state just yet, so just return the same state that was passed in

  // Create a newState variable that begins life as an empty object
  var newState = {}
  switch(action.type) {
    // case "TOGGLE_SINGLE_BOX":
    //   console.log("in reducer switch/case -- TOGGLE_SINGLE_BOX")
    //   // Toggle the boolean for action.boxColor, which will evaluate to either black or blue
    //   newState[action.boxColor] = !state[action.boxColor]
    //   return Object.assign({}, state, newState)
    // case "TOGGLE_BOTH_BOXES":
    //   console.log("in reducer switch/case -- TOGGLE_BOTH_BOXES")
    //   // Toggle the bothBoxes boolean
    //   newState.bothBoxes = !state.bothBoxes;
    //   // Check to see if black and blue are equal
    //   if(state.black === state.blue){
    //     // If so, simply flip each value
    //     newState.black = !state.black;
    //     newState.blue = !state.blue;
    //   } else {
    //     // If not, just set black and blue to the toggled bothBoxes value
    //     newState.black = !state.bothBoxes;
    //     newState.blue = !state.bothBoxes;
    //   }
    //   // Return an updated state w/ Object.assign
    //   return Object.assign({}, state, newState);
    default:
      return state
  }
}

var store = redux.createStore(reducer, initialState)

function mapStateToProps(state){
  console.log('mapStateToProps called')
  return {
    // set the props (from initialState) that will be passed down
    test: state.test
  }
}
function mapDispatchToProps(dispatch){
  return {
    // Which methods do we want our React components to have access to in props?
    testMapDispatch(){
      // alert('inside mapDispatchToProps!')
      dispatch({type:"default"})
    }
  }
}

var reduxConnection = reactRedux.connect(mapStateToProps, mapDispatchToProps)
console.log("just before module.exports in Store, checking reduxConnection...", reduxConnection);
module.exports = {
  store: store,
  reduxConnection: reduxConnection
}



// WEBPACK FOOTER //
// ./src/Store.js